'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  source: null,
  status: null
}, 'MessageDescriptor');
module.exports = exports['default'];